module.exports = __webpack_public_path__ + "static/media/SHSProdIcons_Game.adfae1cc.svg";


//////////////////
// WEBPACK FOOTER
// ./packages/smart-home-support/pages/homepage/resources/SHSProdIcons_Game.svg
// module id = 1602
// module chunks = 0